import Button from '@commons/Button';

/**
 * Blurb button wrapper that makes content clickable.
 * Use this to wrap the entire Blurb or specific parts.
 */
export default function BlurbButton({ href = '', priority = '', children, className = '', ...props }) {
  if (!href) return children;

  const finalClassName = `Blurb__button ${className}`.trim();

  return (
    <Button href={href} priority={priority} className={finalClassName} {...props}>
      {children}
    </Button>
  );
}
